module.exports = __webpack_public_path__ + "static/media/Hutao.300df2ae.png";